import { ActressEntity } from '../actresses/types'

export default class Converter {
  actress: ActressEntity

  constructor(actress: ActressEntity) {
    this.actress = actress
  }

  convert() {
    return {
      id: this.actress.id,
      name: this.actress.name,
      ruby: this.actress.ruby,
      bust: this.actress.bust,
      cup: this.actress.cup,
      waist: this.actress.waist,
      hip: this.actress.hip,
      height: this.actress.height,
      age: this.computeAge(),
      hobby: this.actress.hobby,
      imageURL: this.actress.imageURL,
      rank: this.actress.rank,
      services: this.actress.services,
      servicesLink: this.actress.listURL.digital
    }
  }

  private computeAge() {
    if (!this.actress.birthday) return null

    // https://qiita.com/clockmaker/items/865ceafae7117606169a
    const actressBirthday = new Date(this.actress.birthday)

    const birthday = new Date(
      actressBirthday.getFullYear(),
      actressBirthday.getMonth() -1,
      actressBirthday.getDate()
    )

    const year = birthday.getFullYear().toString().padStart(4, '0')
    const month = (birthday.getMonth() + 1).toString().padStart(2, '0')
    const date = birthday.getDate().toString().padStart(2, '0')

    const today = new Date();
    const todayYear = today.getFullYear().toString().padStart(4, '0')
    const todayMonth = (today.getMonth() + 1).toString().padStart(2, '0')
    const todayDate = today.getDate().toString().padStart(2, '0')

    return Math.floor(
      (
        Number(todayYear + todayMonth + todayDate) - Number(year + month + date)
      ) / 10000
    )
  }
}